export default "__VITE_ASSET__CQ9cRwd0__"